import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Card.css';
import Card from './Card';
import valveimg from '../images/product/valve2.png';
import temp from "../images/product/temp2.png";
import Pressure from "../images/product/Pressure3.png"
import flow from "../images/product/flow2.png"
import Level from "../images/product/level1.png"
import vibrationmonitoring from "../images/product/vibrationmonitoring1.png"
// import gasanalyser from "../images/product/gasanalyser2.png"
import dustmonitors from "../images/product/dustmonitors2.png"
import PLC from "../images/product/PLC1.png"
import liquid from "../images/product/liquid.png"
// valve



const cardData = [
  { title: "Flow", iconSrc: flow, theme: "blue", type: "Flow Measurement  " },
  { title: "Level", iconSrc: Level, theme: "red", type: "Level Measurement  " },
  { title: "Pressure", iconSrc: Pressure, theme: "graydark", type: "Pressure Measurement  " },
  { title: "Temperature", iconSrc: temp, theme: "orange", type: "Temperature Measurement  ", },
  { title: "liquid analyser", iconSrc: liquid, theme: "grayLight", type: "Liquid Analyzers  " },
  { title: "Gas analyser", iconSrc: dustmonitors, theme: "blue", type: "Gas Analyser " },
  { title: "Vibration Monitoring", iconSrc: vibrationmonitoring, theme: "red", type: "vibration monitoring" },
  { title: "Valve", iconSrc: valveimg, theme: "orange", type: " Valve " },
  { title: "PLC & DCS Solutions ", iconSrc: PLC, theme: "blue", type: "" },
];

function Productlist() {
  return (
    <div className="container mt-6 py-5 text-center">
      <h1 className='title-head'>Product Categories </h1>
      <div className="title-decor d-flex justify-content-center align-items-center">
        <div className="line1"></div>
        <div className="dots mx-2">
          <span></span><span></span><span></span>
        </div>
        <div className="line1"></div>
      </div>
      <div className="row mt-4">
        {cardData.map((card, index) => (
          <div className="col-lg-4 col-md-4 col-sm-6 mb-4" key={index}>
            <Card title={card.title} iconSrc={card.iconSrc} theme={card.theme} type={card.type} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Productlist;
